import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import styles from './VNResourceList.module.scss'
import { useSelector } from 'react-redux'

import { getResourceList } from '../selectors/config'

export const VNResourceList = () => {
  const history = useHistory()
  const [currentUri, setCurrentUri] = useState(null)
  const resourceList = useSelector(getResourceList)
  const uris = Object.keys(resourceList).map((key) => {
    return {
      name: key,
      address: resourceList[key],
    }
  })

  const handleItemClick = (uri) => {
    setCurrentUri(uri)
  }

  const handleBack = () => {
    if (currentUri === null) history.push('/user-login')

    setCurrentUri(null)
  }

  return (
    <div className={styles.resourceListWrapper}>
      <div className={styles.iframeHeaderWrapper}>
        {currentUri && (
          <button onClick={handleBack} className={styles.iframeBackButton}>
            Back
          </button>
        )}
        <button onClick={handleBack} className={styles.iframeCloseButton}>
          X
        </button>
      </div>
      {!currentUri && <div className={styles.resourceTitle}>Resources</div>}
      {currentUri ? (
        <div className={styles.iframeWrapper}>
          <iframe src={currentUri} className={styles.iframeContainer} title="Resource Viewer"></iframe>
        </div>
      ) : (
        <ul className={styles.uriList}>
          {uris.map((uri, index) => (
            <li key={index} onClick={() => handleItemClick(uri.address)} className={styles.uriItem}>
              <span>{uri.name}</span>
              <span style={{ fontWeight: 'bold', fontSize: '18px' }}>›</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
